import * as graphql from '@treams/treams-network';

import { useWorkspace } from './useWorkspace';

export function useCompleteWorkspaceCheckpoint(key: string): () => Promise<void> {
	const workspace = useWorkspace();

	const [commit] = graphql.useCompleteWorkspaceCheckpointMutation({
		variables: {
			input: {
				workspaceID: workspace.id,
				key,
			},
		},
	});

	return async () => {
		await commit();
	};
}
